import { useLanguage } from "../context/LanguageContext";
import { Link } from "react-router-dom";
import trainerImg from "../assets/img/trainer.jpg";

export const About = () => {
  const { t } = useLanguage();
  const a = t.about;

  const timeline = [a.t1, a.t2, a.t3, a.t4, a.t5];

  return (
    <div className="page page-about">
      <section className="about-hero">
        <img src={trainerImg} alt={a.heroTitle} />
        <div className="about-hero-text">
          <h1>{a.heroTitle}</h1>
          <p>{a.heroSubtitle}</p>
        </div>
      </section>

      <section className="section about-timeline-section">
        <h2>{a.timelineTitle}</h2>
        <ul className="about-timeline">
          {timeline.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      </section>

      <section className="section about-story-section">
        <h2>{a.storyTitle}</h2>
        <p>{a.story1}</p>
        <p>{a.story2}</p>
        <p>{a.story3}</p>
      </section>

      <section className="section about-cta-section">
        <Link className="btn btn-primary" to="/ochno">
          {a.ctaOchno}
        </Link>
        <Link className="btn btn-secondary" to="/online">
          {a.ctaOnline}
        </Link>
      </section>
    </div>
  );
};
